import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "c:\\wamp64\\www\\Okra\\apps\\web\\src\\components\\providers.tsx");
;
import(/* webpackMode: "eager" */ "c:\\wamp64\\www\\Okra\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\app\\\\layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "c:\\wamp64\\www\\Okra\\apps\\web\\src\\app\\globals.css");
